export const API_URL = import.meta.env.VITE_API_URL;
export const BLOG_HOST = import.meta.env.VITE_BLOG_HOST;
export const HEADERS = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
};
